module.exports = __webpack_public_path__ + "img/button3.454477d5.png";